/* eslint-disable indent */
<template>
<div class="md-layout">
    <div class="md-layout-item">
        <md-card>
            <header-form title="PERMISSÕES DO NÍVEIS DE ACESSO" :rota="{name: 'niveis_acessoRead'}" tooltip="Lista de níveis de acesso" />

            <md-card-content>
                <div class="md-layout">
                    <div class="md-layout-item md-size-100 md-xsmall-size-100">
                        <md-tabs class="md-info mdTabs">
                            <md-tab v-if="listPermissoes.niveis_acessoRemovePermissao" id="tab-permissoes" md-label="Permissões" md-icon="vpn_key">
                                <md-table v-model="searched" md-card @md-selected="selectDelete" md-fixed-header>
                                    <md-table-toolbar>
                                        <div class="md-toolbar-section-start"></div>
                                        <md-field md-clearable class="md-toolbar-section-end">
                                            <md-input placeholder="Pesquise aqui..." v-model="search" @input="searchOnTable" />
                                        </md-field>
                                    </md-table-toolbar>

                                    <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="multiple" md-auto-select class="tableRow">
                                        <md-table-cell md-label="ID" style="width: 5%" md-sort-by='id' md-numeric>{{ item.id }}</md-table-cell>
                                        <md-table-cell class="uppercase" md-label="NOME" style="width: 35%" md-sort-by="nome">{{ item.nome }}</md-table-cell>
                                        <md-table-cell class="uppercase" md-label="DESCRIÇÃO" style="width: 40%" md-sort-by="descricao">{{ item.descricao }}</md-table-cell>
                                        <md-table-cell class="uppercase" md-label="GRUPO" style="width: 20%" md-sort-by="grupo">{{ item.grupo }}</md-table-cell>
                                    </md-table-row>
                                </md-table>
                                <md-card-actions class="cardActions">
                                    <div class="md-toolbar-section-start">
                                        <h3 class="uppercase text-secondary"><strong>{{ nivelAcesso.nome }}</strong></h3>
                                    </div>
                                    <md-button @click="removePermissoes" class="md-danger md-round">
                                        <span class="md-label">
                                            <md-icon class="material-icons">delete</md-icon>
                                        </span>EXCLUIR
                                    </md-button>
                                </md-card-actions>
                            </md-tab>

                            <md-tab v-if="listPermissoes.niveis_acessoAddPermissao" id="tab-add-permissoes" md-label="Adicionar Permissões" md-icon="add">
                                <md-table v-model="searchedPermissoaes" md-card @md-selected="selectAdd" md-fixed-header>
                                    <md-table-toolbar>
                                        <div class="md-toolbar-section-start"></div>
                                        <md-field md-clearable class="md-toolbar-section-end">
                                            <md-input placeholder="Pesquise aqui..." v-model="search" @input="searchOnTablePermissao" />
                                        </md-field>
                                    </md-table-toolbar>

                                    <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="multiple" md-auto-select class="tableRow">
                                        <md-table-cell md-label="ID" style="width: 5%" md-sort-by='id' md-numeric>{{ item.id }}</md-table-cell>
                                        <md-table-cell class="uppercase" md-label="NOME" style="width: 35%" md-sort-by="nome">{{ item.nome }}</md-table-cell>
                                        <md-table-cell class="uppercase" md-label="DESCRIÇÃO" style="width: 40%" md-sort-by="descricao">{{ item.descricao }}</md-table-cell>
                                        <md-table-cell class="uppercase" md-label="GRUPO" style="width: 20%" md-sort-by="grupo">{{ item.grupo }}</md-table-cell>
                                    </md-table-row>
                                </md-table>
                                <md-card-actions class="cardActions">
                                    <div class="md-toolbar-section-start">
                                        <h3 class="uppercase text-secondary"><strong>{{ nivelAcesso.nome }}</strong></h3>
                                    </div>
                                    <md-button @click="adicionarPermissoes" class="md-success md-round">
                                        <span class="md-label">
                                            <md-icon class="material-icons">add</md-icon>
                                        </span>ADICIONAR
                                    </md-button>
                                </md-card-actions>
                            </md-tab>
                        </md-tabs>
                    </div>
                </div>
            </md-card-content>

        </md-card>
    </div>
</div>
</template>

<script>
import Notify from '@/config/mixins/notify'
import preLoader from '@/config/mixins/preLoader';
import HeaderForm from '@/pages/Layout/Extra/HeaderForm'

const toLower = text => {
    return text.toString().toLowerCase()
}

const searchByName = (items, term) => {
    if (term) {
        return items.filter(item => toLower([item.nome, item.decricao, item.grupo]).includes(toLower(term)))
    }

    return items
}

export default {
    name: 'NiveisAcessoRead',
    components: {
        HeaderForm
    },

    mixins: [Notify, preLoader],

    data() {
        return {
            dados: {},
            listPermissoes: this.$store.state.usuario.permissao,
            nivelAcesso: {},
            permissoesNivelAcesso: [],
            permissoes: [],
            deletePermissoes: [],
            addPermissoes: [],
            totalSelecionado: 0,
            search: null,
            searched: [],
            searchedPermissoaes: [],
            buscar: {
                busca: ''
            }
        };
    },

    created() {
        this.getPermissoes()
        this.searched = this.permissoesNivelAcesso
        this.searchedPermissoaes = this.permissoes
    },

    methods: {
        getPermissoes() {
            this.$http.get(this.$urlAPI + 'niveis_acessos/listaPermissao/' + this.$route.params.id)
                .then(response => {
                    if (response.data.status) {
                        this.nivelAcesso = response.data.nivel;
                        this.permissoesNivelAcesso = response.data.dados;
                        this.permissoes = response.data.permissoes;
                        this.searched = response.data.dados
                        this.searchedPermissoaes = response.data.permissoes
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },

        searchOnTable() {
            this.searched = searchByName(this.permissoesNivelAcesso, this.search)
        },

        searchOnTablePermissao() {
            this.searchedPermissoaes = searchByName(this.permissoes, this.search)
        },

        selectDelete(items) {
            let item = []
            items.forEach(element => {
                item.push(element.id)
            });
            this.deletePermissoes = item
        },

        selectAdd(items) {
            let item = []
            items.forEach(element => {
                item.push(element.id)
            });
            this.addPermissoes = item
        },

        removePermissoes() {
            if (this.deletePermissoes.length === 0) {
                return this.warning('Selecione pelo menos uma Permissão antes de excluir!')
            }
            this.dados.id = this.nivelAcesso.id
            this.dados.permissoes = this.deletePermissoes
            this.$http.post(this.$urlAPI + 'niveis_acessos/remove_permissao', this.dados)
                .then(response => {
                    if (response.data.status) {
                        this.nivelAcesso = response.data.nivel;
                        this.permissoesNivelAcesso = response.data.dados;
                        this.permissoes = response.data.permissoes;
                        this.searched = response.data.dados
                        this.searchedPermissoaes = response.data.permissoes
                        this.success(response.data.message)
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },

        adicionarPermissoes() {
            if (this.addPermissoes.length === 0) {
                return this.warning('Selecione pelo menos uma Permissão antes de adicionar!')
            }
            this.dados.id = this.nivelAcesso.id
            this.dados.permissoes = this.addPermissoes
            this.$http.post(this.$urlAPI + 'niveis_acessos/adiciona_permissao', this.dados)
                .then(response => {
                    if (response.data.status) {
                        this.nivelAcesso = response.data.nivel;
                        this.permissoesNivelAcesso = response.data.dados;
                        this.permissoes = response.data.permissoes;
                        this.searched = response.data.dados
                        this.searchedPermissoaes = response.data.permissoes
                        this.success(response.data.message)
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        }
    },
}
</script>

<style lang="scss" scoped>
.md-tab {
    margin-top: -50px !important;
}

.mdTabs {
    margin-top: 30px;
}
</style>
